<template>
  <div class="parcelle-popup">
    <div class="popup-header">
      <h3 class="popup-title">{{ feature.properties.parcel_id || 'Parcelle' }}</h3>
    </div>

    <div class="popup-content">
      <div class="info-section">
        <div class="info-row">
          <span class="info-label">Producteur :</span>
          <span class="info-value">{{ feature.properties.ProducerName }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Code producteur :</span>
          <span class="info-value">{{ feature.properties.ProducerCode }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Statut :</span>
          <span class="info-value statut-badge" :class="'statut-' + feature.properties.Statut">
            {{ feature.properties.Statut }}
          </span>
        </div>
        <div class="info-row">
          <span class="info-label">Superficie :</span>
          <span class="info-value">{{ feature.properties.Area }} ha</span>
        </div>
        <div v-if="feature.properties.ProduitCultive" class="info-row">
          <span class="info-label">Produit cultivé :</span>
          <span class="info-value">{{ feature.properties.ProduitCultive }}</span>
        </div>
        <div v-if="feature.properties.DateModification" class="info-row">
          <span class="info-label">Dernière modification :</span>
          <span class="info-value">{{ feature.properties.DateModification }}</span>
        </div>
      </div>

      <div class="location-section">
        <div class="info-row">
          <span class="info-label">Village :</span>
          <span class="info-value">{{ feature.properties.Village }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Commune :</span>
          <span class="info-value">{{ feature.properties.Commune }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Zone :</span>
          <span class="info-value">{{ feature.properties.Zone }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Région :</span>
          <span class="info-value">{{ feature.properties.Region }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Groupement :</span>
          <span class="info-value">{{ feature.properties.Groupement }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Unité de production :</span>
          <span class="info-value">{{ feature.properties.UniteProduction }}</span>
        </div>
      </div>

      <div v-if="feature.properties.historique" class="historique-section">
        <h4 class="section-title">Historique</h4>
        <div class="historique-content" v-html="feature.properties.historique" />
      </div>
    </div>

    <div class="popup-footer">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-view"
        @click="viewDetails"
      >
        Voir détails
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParcellePopup',
  props: {
    feature: {
      type: Object,
      required: true,
    },
  },
  methods: {
    viewDetails() {
      const parcelleId = this.feature.properties.parcelle_id;
      if (parcelleId) {
        this.$router.push({ path: `/parcelles/${parcelleId}` });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.parcelle-popup {
  margin: 10px;
  max-width: 400px;
  font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;

  .popup-header {
    border-bottom: 2px solid #e4e7ed;
    padding-bottom: 12px;
    margin-bottom: 16px;

    .popup-title {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }

  .popup-content {
    max-height: 400px;
    overflow-y: auto;

    .info-section,
    .location-section {
      margin-bottom: 16px;
    }

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 8px 0;
      border-bottom: 1px solid #f5f7fa;

      &:last-child {
        border-bottom: none;
      }

      .info-label {
        font-weight: 600;
        color: #606266;
        font-size: 13px;
        flex: 0 0 45%;
      }

      .info-value {
        color: #303133;
        font-size: 13px;
        text-align: right;
        flex: 1;
        word-break: break-word;

        &.statut-badge {
          display: inline-block;
          padding: 2px 8px;
          border-radius: 4px;
          font-weight: 600;
          font-size: 12px;

          &.statut-AB {
            background-color: #e6f7e6;
            color: #00ab53;
          }

          &.statut-C1 {
            background-color: #e6f4ff;
            color: #1890ff;
          }

          &.statut-C2 {
            background-color: #fff7e6;
            color: #fa8c16;
          }

          &.statut-C3 {
            background-color: #fff1f0;
            color: #f5222d;
          }
        }
      }
    }

    .historique-section {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 2px solid #e4e7ed;

      .section-title {
        margin: 0 0 8px 0;
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }

      .historique-content {
        font-size: 12px;
        color: #606266;
        line-height: 1.6;
      }
    }
  }

  .popup-footer {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 2px solid #e4e7ed;
    display: flex;
    justify-content: flex-end;
  }
}

// Scrollbar styling
.popup-content::-webkit-scrollbar {
  width: 6px;
}

.popup-content::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

.popup-content::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;

  &:hover {
    background: #909399;
  }
}
</style>

